import { api } from "../../../lib/api";

export const T_STATUS = {
  open: { label: "Baru", tint: "bg-sky-50 text-sky-700" },
  assigned: { label: "Ditugaskan", tint: "bg-indigo-50 text-indigo-700" },
  in_progress: { label: "Diproses", tint: "bg-blue-50 text-blue-700" },
  escalated: { label: "Eskalasi L2", tint: "bg-violet-50 text-violet-700" },
  waiting_user: { label: "Menunggu pengguna", tint: "bg-amber-50 text-amber-700" },
  resolved: { label: "Selesai", tint: "bg-emerald-50 text-emerald-700" },
  closed: { label: "Ditutup", tint: "bg-slate-100 text-slate-600" },
};
export const T_PRIORITY = {
  low: { label: "Rendah", tint: "bg-slate-100 text-slate-600" },
  normal: { label: "Normal", tint: "bg-blue-50 text-blue-700" },
  high: { label: "Tinggi", tint: "bg-orange-50 text-orange-700" },
  urgent: { label: "Mendesak", tint: "bg-rose-50 text-rose-700" },
};
export const T_CATEGORY = { billing: "Billing & Pembayaran", technical: "Teknis", account: "Akun & Keamanan", feature: "Fitur & Saran", other: "Pertanyaan Lain" };
export const SUPPORT_ROLES = ["super_admin", "support_manager", "support_tech", "support_l2"];
export const STATUS_NOTES = { in_progress: "Tiket diklaim/diproses oleh Anda.", waiting_user: "Pengguna diberi tahu untuk melengkapi informasi.", resolved: "Pengguna dapat membuka kembali ≤ 7 hari.", closed: "Tiket ditutup permanen.", open: "Kembalikan ke antrean baru." };

export const statusDef = (s, t) => T_STATUS[s] || { label: t?.status_label || s || "—", tint: "bg-slate-100 text-slate-600" };
export const prioDef = (p) => T_PRIORITY[p] || { label: p || "—", tint: "bg-slate-100 text-slate-600" };
export const catLabel = (c, t) => t?.category_label || T_CATEGORY[c] || c || "—";

// Role → what the console lets the staff do (server enforces the same rules).
export function perms(role) {
  const mgr = ["super_admin", "support_manager"].includes(role);
  return {
    assign: mgr, escalate: mgr || role === "support_tech", faqWrite: mgr, reseed: role === "super_admin",
    statuses: mgr ? ["in_progress", "waiting_user", "resolved", "closed", "open"] : role === "support_tech" ? ["in_progress", "waiting_user", "resolved"] : ["in_progress", "resolved", "closed"],
  };
}

export const fmtDt = (iso) => (iso ? new Date(iso).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export function fmtRel(iso) {
  if (!iso) return "—";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "baru saja"; if (s < 3600) return `${Math.floor(s / 60)} mnt lalu`; if (s < 86400) return `${Math.floor(s / 3600)} jam lalu`; if (s < 7 * 86400) return `${Math.floor(s / 86400)} hari lalu`;
  return fmtDt(iso);
}
export const fetchFileBlob = (path) => api.get(`/files/${path}`, { responseType: "blob" }).then((r) => r.data);
export const fmtSize = (b) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : b >= 1024 ? `${Math.round(b / 1024)} KB` : `${b || 0} B`);
export const TICKET_PAGE = 50;
